// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","EventsWrapper":"EventsWrapper-27hyngxtg2k6fzs83mfvfa4espfmcgg8bfh79wmhw8kcujt3qmabggba37dbuah9yamd96ckwgkcj32mwbe3jxpf7zata2rrb7vbw5t","loading":"loading-2u9snp7s4wd6gytkx14n4yvfwpy9swttq8truynn92fbpaazm8bcxxcuu6dxh3q2qg1mhtkxgurspwze4pv1zu1jjcd5bc2ve8nhuzv","pulse":"pulse-367sev2jh67aa15z6mxxe13h72rwrgrv71zjv3bxef4w6q5d3hvmwfqtkc792yjvj7hxu9xpb4f1ahpbp9buc6dmagkd69d1895pjca"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PlannedEvents/PlannedEvents.module.scss
// module id = 1728
// module chunks = 0